import { useCallback } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { setAssessmentInstrument } from '../../../../../redux_store';
import AssessmentSelector from './AssessmentSelector';

const useStyles = makeStyles((theme) => ({
  controlGroup: {
    flex: '0 0 auto',
    paddingBottom: theme.spacing(0),
    borderBottom: 'none',
    marginBottom: theme.spacing(0),

    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(2),
      borderBottom: 'none',
      marginBottom: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: 1.5,
    textTransform: 'uppercase',
    color: '#9196A6',
    marginBottom: theme.spacing(1.5),
  },
  selectorWrapper: {
    '& > div': {
      width: '100%',
      backgroundColor: '#F7F8FA',
      borderRadius: 8,
      border: '1px solid #E6E9F0',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: '#F1F3F5',
        borderColor: '#D3D6DC',
      },
    },
  },
}));

const AssessmentFilter = ({ style }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { populationHealth } } = useSelector((state) => state.i18n);
  const { selectedInstrument, assessmentInstruments, surveysStatus } = useSelector((state) => state.populationHealth);

  const handleInstrumentChange = useCallback((instrument) => {
    // Если передан объект с id, используем id, иначе передаем значение как есть
    const value = instrument?.id || instrument;
    dispatch(setAssessmentInstrument(value));
  }, [dispatch]);

  return (
    <div className={classes.controlGroup} style={style}>
      <Typography className={classes.sectionTitle}>
        {populationHealth?.assessmentType || 'Assessment Type'}
      </Typography>
      <div className={classes.selectorWrapper}>
        <AssessmentSelector
          selectedInstrument={selectedInstrument}
          onInstrumentChange={handleInstrumentChange}
          assessmentInstruments={assessmentInstruments}
          surveysStatus={surveysStatus}
        />
      </div>
    </div>
  );
};

export default AssessmentFilter;
